



































































































































































import { Component, Prop } from 'vue-property-decorator';
import { Teacher } from '../../../src_server/entity/generated/Teacher';
import { InputPages } from '../../components/organisms/InputPages';
import { subjectsOptions } from '../../../src_server/entity/master/subjectsData';
import { schoolYearsOptions } from '../../../src_server/entity/master/schoolYearsData';
import SimpleCheckBox from '../../components/inputs/SimpleCheckBox.vue';

@Component({
  components: {},
})
export default class TeacherLeadershipPage extends InputPages {
  @Prop()
  value!: Teacher;

  get model() {
    return this.value;
  }

  set model(value) {
    this.value = value;
  }
  get subjects() {
    return subjectsOptions;
  }

  get schoolYears() {
    return schoolYearsOptions;
  }
}
